<template>
  <div class="nav-header flex-box">
    <div class="flex-box g-header-left">
      <i class="iconfont" :class="icon"></i>
      <h3 class="title">{{title || $route.name}}</h3>
    </div>
    <slot name="rightBtn"></slot>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    created() {
    },
    mounted() {

    },
    props: {
      icon: {
        type: String,
        default: 'icon-fenpei'
      },
      title: {
        type: String,
        default: ''
      }
    },
    computed: {

    },
    methods: {
    },
    components: {},
    watch: {}
  }
</script>
<style scoped lang="scss">
  @import '../assets/css/mixin';
  .nav-header {
    justify-content: space-between;
    height:58px;
    border-bottom: 1px solid #CCC;
    padding: 0 14px;
    i{
      @include sc(18px,#333);
      @include wh(24px,24px);
      text-align: center;
      line-height: 24px;
      margin-right: 8px;
    }
  }
  .title {
    font-size: 16px;
    color: #333;
    line-height: 22px;
  }
</style>



// WEBPACK FOOTER //
// src/components/header.vue